export const ALLTICKETS_RECEIVE_REQUEST = "TICKETS_RECEIVE_REQUEST";
export const ALLTICKETS_RECEIVE_SUCCESS = "TICKETS_RECEIVE_SUCCESS";
export const ALLTICKETS_RECEIVE_FAIL = "TICKETS_RECEIVE_FAIL";

export const MERCHANTTICKETS_RECEIVE_REQUEST = "MERCHANTTICKETS_RECEIVE_REQUEST";
export const MERCHANTTICKETS_RECEIVE_SUCCESS = "MERCHANTTICKETS_RECEIVE_SUCCESS";
export const MERCHANTTICKETS_RECEIVE_FAIL =    "MERCHANTTICKETS_RECEIVE_FAIL";

export const SINGLETICKET_RECEIVE_REQUEST = "SINGLETICKET_RECEIVE_REQUEST";
export const SINGLETICKET_RECEIVE_SUCCESS = "SINGLETICKET_RECEIVE_SUCCESS";
export const SINGLETICKET_RECEIVE_FAIL = "SINGLETICKET_RECEIVE_FAIL";

export const MESSAGE_SEND_REQUEST = "MESSAGE_SEND_REQUEST";
export const MESSAGE_SEND_SUCCESS = "MESSAGE_SEND_SUCCESS";
export const MESSAGE_SEND_FAIL = "MESSAGE_SEND_FAIL";

export const TICKET_CREATE_REQUEST = "TICKET_CREATE_REQUEST";
export const TICKET_CREATE_SUCCESS = "TICKET_CREATE_SUCCESS";
export const TICKET_CREATE_FAIL = "TICKET_CREATE_FAIL";

export const TICKET_ASSIGN_REQUEST = "TICKET_ASSIGN_REQUEST";
export const TICKET_ASSIGN_SUCCESS = "TICKET_ASSIGN_SUCCESS";
export const TICKET_ASSIGN_FAIL    =  "TICKET_ASSIGN_FAIL";

export const TICKET_CLOSE_FAIL = "TICKET_CLOSE_FAIL"
export const TICKET_CLOSE_SUCCESS = "TICKET_CLOSE_SUCCESS"
export const TICKET_CLOSE_REQUEST = "TICKET_CLOSE_REQUEST"